class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.cartLinks = document.querySelectorAll('[data-cart-link], a.cart[href]');
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    document.addEventListener('shopify:section:load', this.setHeaderCartIconAccessibility.bind(this));
    const cartDrawerSection = document.querySelector('#shopify-section-cart-drawer');
    cartDrawerSection?.addEventListener('shopify:section:select', this.sectionSelect.bind(this));
    cartDrawerSection?.addEventListener('shopify:section:deselect', this.close.bind(this));
  }

  get drawerInner() {
    return this.querySelector('.drawer__inner');
  }

  setHeaderCartIconAccessibility() {
    this.cartLinks = document.querySelectorAll('[data-cart-link], a.cart[href]');
    Array.from(this.cartLinks).forEach(cartLink => {
      if (cartLink.dataset.cartDrawerBound === 'true') return;
      cartLink.dataset.cartDrawerBound = 'true';
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (['Enter', 'Space'].includes(event.code)) {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    })
  }

  sectionSelect() {
    this.cartLink = document.querySelector('[data-cart-link], a.cart[href]')
    this.open(this.cartLink)
  }

  open(triggeredBy) {
    const drawerInner = this.drawerInner;
    if (!drawerInner) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {this.classList.add('animate', 'active')});
    document.body.classList.add('hidden');
    drawerInner.setAttribute('tabindex', '0')
    const elementToFocus = drawerInner.querySelector('.drawer__close, a, button, input, select, textarea');
    setTimeout(() => trapFocus(drawerInner, elementToFocus || drawerInner), 10)
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('hidden')
    document.dispatchEvent(new CustomEvent('body:visible'));
    this.drawerInner?.setAttribute('tabindex', '-1')
  }

  renderContents(parsedState) {
    this.drawerInner?.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionHTML = parsedState.sections?.[section.id];
      if (!sectionHTML) return;
      const sectionContent = this.getSectionInnerHTML(sectionHTML, section.selector);
      if (sectionContent === null) return;
      const sectionElements = document.querySelectorAll(section.selector);
      if(sectionElements.length) {
        Array.from(sectionElements).forEach(sectionElement => {
          sectionElement.innerHTML = sectionContent;
        })
      } 
    }));

    if(this.className.includes('open-after-adding')) {
      setTimeout(() => {
        this.open();
      });
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const source = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return source?.innerHTML ?? null;
  }

  getSectionsToRender() {
    let arraySections = []
    if (window.innerWidth > 920 && document.querySelector('.header-without-sidebars')) {
      arraySections = [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer'
        },
        {
          id: 'menu-drawer',
          selector: '#cart-icon-bubble-menu-drawer'
        },
        {
          id: 'header',
          selector: '#cart-icon-bubble-header'
        },
        {
          id: 'secondary-sidebar',
          selector: '#cart-icon-bubble-secondary-sidebar'
        },
        {
          id: 'main-sidebar',
          selector: '#cart-icon-bubble-main-sidebar'
        }
      ];
    } else if (window.innerWidth > 920 && document.querySelector('.secondary-header-section')) {
      arraySections = [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer'
        },
        {
          id: 'menu-drawer',
          selector: '#cart-icon-bubble-menu-drawer'
        },
        {
          id: 'secondary-header',
          selector: '#cart-icon-bubble-secondary-header'
        },
        {
          id: 'secondary-sidebar',
          selector: '#cart-icon-bubble-secondary-sidebar'
        },
        {
          id: 'main-sidebar',
          selector: '#cart-icon-bubble-main-sidebar'
        }
      ];
    } else {
      arraySections = [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer'
        },
        {
          id: 'menu-drawer',
          selector: '#cart-icon-bubble-menu-drawer'
        },
        {
          id: 'mobile-header',
          selector: '#cart-icon-bubble-mobile-header'
        }
      ];
    }
    return arraySections
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);
